import React, {Dispatch, SetStateAction} from "react";
import {
    AllStates,
    StepForm,
    TranslateFunction
} from '../Forms';

import schema from './languages.schema.json';

import {JSONSchema7} from "json-schema";
import {ErrorObject} from "ajv";
import {I18nMessage} from "../Representation";

const FORM_NS = "languages_form.";

export class LanguagesFormInfoOnly extends StepForm {

    constructor() {
        super(schema as JSONSchema7);
    }

    getFormNs(): string | undefined {
        return FORM_NS;
    }

    getTitleKey() {
        return "languages_title";
    };

    getPage([formData, setFormData]: [any, Dispatch<SetStateAction<any>>],  allStates: AllStates, t: TranslateFunction, lang: string) {
        return (<React.Fragment>

        </React.Fragment>);
    }

    getContextMessageKeys = (data: any, _allStates: AllStates): [I18nMessage[], I18nMessage[]] => {
        return [[],[]];
    }

    filterValidationErrors(data: any, errors: ErrorObject[] | null | undefined) {
        return [];
    }

    getExplanationMarkdownKey() {
        return "languages.explanation.markdown";
    }

    getHelpUrl(): string {
        return "faq.html#languages";
    }

}